{
	"name": "somerville-req-app",
	"version": "1.5.1",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"build": "node scripts/generate-version.js && ng build",
		"build:prod": "node scripts/generate-version.js && ng build --configuration production",
		"build:dev": "node scripts/generate-version.js && ng build --configuration development",
		"start:local": "ng serve --configuration local",
		"build:local": "node scripts/generate-version.js && ng build --configuration local",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"version:patch": "node scripts/update-version.js patch",
		"version:minor": "node scripts/update-version.js minor",
		"version:major": "node scripts/update-version.js major",
		"version:generate": "node scripts/generate-version.js",
		"notes": "start RELEASE_NOTES.txt",
		"notes:clear": "echo. > RELEASE_NOTES.txt",
		"hooks:install": "node scripts/install-hooks.js"
	},
	"private": true,
	"dependencies": {
		"@angular/common": "^21.2.13",
		"@angular/compiler": "^21.2.13",
		"@angular/core": "^21.2.13",
		"@angular/forms": "^21.2.13",
		"@angular/platform-browser": "^21.2.13",
		"@angular/platform-browser-dynamic": "^21.2.13",
		"@angular/router": "^21.2.13",
		"@ddtmm/angular-signal-generators": "^4.0.2",
		"@grafana/faro-web-sdk": "^2.7.1",
		"@primeuix/themes": "^2.0.2",
		"@tailwindcss/postcss": "^4.1.18",
		"luxon": "3.7.2",
		"primeicons": "7.0.0",
		"primeng": "21.0.2",
		"rxjs": "~7.8.2",
		"signature_pad": "5.1.3",
		"socket.io-client": "^4.8.3",
		"tailwindcss": "^4.1.18",
		"tailwindcss-primeui": "^0.6.1",
		"tslib": "^2.8.1"
	},
	"overrides": {
		"undici": "^7.25.0",
		"handlebars": "^4.7.9",
		"ajv": "^8.18.0",
		"vite": "^7.3.2",
		"picomatch": "^4.0.4"
	},
	"devDependencies": {
		"@angular-eslint/eslint-plugin": "21.1.0",
		"@angular/build": "^21.2.11",
		"@angular/cli": "^21.2.11",
		"@angular/compiler-cli": "^21.2.13",
		"@eslint/js": "^9.39.2",
		"@types/jasmine": "~5.1.13",
		"@types/luxon": "3.7.1",
		"angular-eslint": "21.1.0",
		"eslint": "^9.39.2",
		"eslint-config-prettier": "10.1.8",
		"eslint-plugin-boundaries": "^5.3.1",
		"eslint-plugin-html": "8.1.3",
		"eslint-plugin-perfectionist": "5.2.0",
		"eslint-plugin-prettier": "5.5.4",
		"eslint-plugin-unused-imports": "4.3.0",
		"jasmine-core": "~5.13.0",
		"karma": "~6.4.4",
		"karma-chrome-launcher": "~3.2.0",
		"karma-coverage": "~2.2.1",
		"karma-jasmine": "~5.1.0",
		"karma-jasmine-html-reporter": "~2.1.0",
		"postcss": "^8.5.4",
		"prettier": "^3.7.4",
		"prettier-plugin-tailwindcss": "^0.7.2",
		"typescript": "~5.9.3",
		"typescript-eslint": "^8.51.0"
	}
}